import React from 'react';
import { PathwayButton } from './PathwayButton';
interface PathwayPaginationProps {
  label: string;
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
}

/** Shared pager for the pathway tables and results list. */
export function PathwayPagination({
  label,
  page,
  pageCount,
  onChange
}: PathwayPaginationProps) {
  if (pageCount <= 1) return null;
  return <nav aria-label={label} className="mt-4 flex items-center justify-between gap-3" data-id="element-1681" data-mp="5o2woysgka6e">
      <PathwayButton variant="secondary" size="sm" onClick={() => onChange(Math.max(1, page - 1))} disabled={page === 1} data-id="element-1682" data-mp="anfkblr5lla1">
        Previous
      </PathwayButton>
      <span className="text-sm text-gray-600" data-id="element-1683" data-mp="o6rwxbxseps">
        Page {page} of {pageCount}
      </span>
      <PathwayButton variant="secondary" size="sm" onClick={() => onChange(Math.min(pageCount, page + 1))} disabled={page === pageCount} data-id="element-1684" data-mp="1r1fjgui6d6w8">
        Next
      </PathwayButton>
    </nav>;
}